define('helpers/timezone-helper',['require','underscore','moment','momentTimezone'],function(require) {
  var GROUPED_LIST, LEGACY_LIST, OTHER_ZONES, TimezoneHelper, US_STANDARD, moment, momentTimezone, _, _formatZoneDisplay, _formatZoneItem, _formatZoneItemLegacy;
  _ = require("underscore");
  moment = require("moment");
  momentTimezone = require("momentTimezone");
  US_STANDARD = ["America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles"];
  OTHER_ZONES = _.filter(_.uniq(moment.tz.names()), function(zone) {
    return !(zone.match(/^US/) || _.contains(US_STANDARD, zone));
  });
  _formatZoneDisplay = function(zone) {
    var abbr;
    abbr = moment.tz(zone).zoneName();
    return abbr + " - " + zone;
  };
  _formatZoneItem = function(zone) {
    return {
      value: zone,
      label: _formatZoneDisplay(zone)
    };
  };
  _formatZoneItemLegacy = function(zone) {
    return {
      val: zone,
      val_display: _formatZoneDisplay(zone)
    };
  };
  LEGACY_LIST = _.map(US_STANDARD, _formatZoneItemLegacy).concat([
    {
      val_display: "---"
    }
  ], _.map(OTHER_ZONES, _formatZoneItemLegacy));
  GROUPED_LIST = [
    {
      label: "Standard USA",
      items: _.map(US_STANDARD, _formatZoneItem)
    }, {
      label: "All Timezones",
      items: _.sortBy(_.map(OTHER_ZONES, _formatZoneItem), "label")
    }
  ];
  return TimezoneHelper = {
    findSetValue: function(val) {
      return {
        label: _formatZoneDisplay(val),
        value: val
      };
    },
    getFormattedList: function() {
      return LEGACY_LIST;
    },
    getFormattedGroups: function() {
      return GROUPED_LIST;
    }
  };
});

//# sourceMappingURL=timezone-helper.js.map
;
